// @flow strict
import type {SchedulerEvent} from 'src/types/scheduler';
// $FlowFixMe[nonstrict-import]
import format from 'date-fns/format';

// Mon, Jul 7, 9:15 AM GMT+5:30
export function formatDateTime(
  date: Date,
  t: (string, string) => string,
  makeKey: (string) => string,
): string {
  const day = format(date, 'EEEE');
  const month = format(date, 'MMMM');

  const timeWithTimeZone = date.toLocaleTimeString(undefined, {
    timeZoneName: 'short',
    hour: 'numeric',
    minute: 'numeric',
  });

  return `${t(makeKey(day), day)}, ${t(
    makeKey(month),
    month,
  )} ${date.getDate()}, ${timeWithTimeZone}`;
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString(undefined, {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  });
}

const getHash = async (
  eventId: string,
  participantType: string,
): Promise<string> => {
  const hashString = `${participantType}_${eventId}`;
  const encoder = new TextEncoder();
  const data = encoder.encode(hashString);
  const hash = await window.crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hash));
  const hexDigest = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
  const shortDigest = hexDigest.substring(0, 16);
  return shortDigest;
};

export const getLinkOwner = async (
  eventId: string,
  params: {[string]: string},
): Promise<'HOST' | 'GUEST' | 'NO_OWNER'> => {
  const hostShortDigest = await getHash(eventId, 'host');
  const guestShortDigest = await getHash(eventId, 'guest');

  return params.attendee === hostShortDigest
    ? 'HOST'
    : params.attendee === guestShortDigest
    ? 'GUEST'
    : 'NO_OWNER';
};

export const getLinkOwnerLanguage = ({
  linkOwner,
  userId,
  eventData,
}: {
  linkOwner: 'HOST' | 'GUEST' | 'NO_OWNER',
  userId: string,
  eventData: SchedulerEvent,
}): ?string => {
  const userArray =
    linkOwner === 'HOST'
      ? eventData.interviewers
      : linkOwner === 'GUEST'
      ? eventData.candidates
      : null;

  if (!Array.isArray(userArray)) {
    return null;
  }

  const userData = userArray.find((user) => user.id === userId);
  return userData?.language ?? null;
};
